const mapping: Record<string, string> = {
  id: 'l=>l.Id',
}

export const mapSortItemParam = (key: string) => mapping[key]
